<template>
    <div class="mortgage-summary-help-popup">
        <popup :close-action="closePopUp" class="popup" :buttons="buttons">
            <template v-slot:title>
                <div class="ri-large-headline margin-top-l">איפה מוצאים את דוח היתרות של המשכנתא?</div>
            </template>
            <template v-slot:content>
            <div class="ri-body">
                <p class="margin-bottom-m">
                דוח יתרות הוא מסמך רשמי מהבנק שמציג את מצב ההלוואה שלך: כמה נותר לשלם, באילו מסלולים, ומה גובה ההחזר החודשי.
                </p>
                <p class="margin-bottom-m">
                כדי להוריד אותו, אפשר להיכנס
                <span class="bold">לאזור האישי באתר או באפליקציה</span>
                של הבנק שבו לקחת את המשכנתא. בפרטי המשכנתאות אמור להופיע סעיף בשם "דוח יתרות", "דוח סילוקין" או "מצב חשבון משכנתא".
                </p>
                <info-tool-tip class="mortgage-summary-help-info-tooltip"
                 :text="'אם לא מצאת — כדאי לפנות לנציג הבנק ולבקש לקבל את הדוח במייל.'"
                 icon-path="/images/onboarding/icons/leaf-icon.svg"
                 :backgroundColor="'#E8F4BA'"/>
            </div>
      </template>
    </popup>
    </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import InfoToolTip from '@/base-components/onboarding/InfoToolTip';

export default {
  name: 'MortgageSummaryHelp',
  components: {
    Popup: BaseUI.Popup,
    InfoToolTip,
  },
  computed: {
    buttons() {
      return [
        {
          title: 'הבנתי, אפשר להמשיך',
          action: this.closePopUp,
          size: 'slim',
          variant: 'secondary',
          color: 'green',
        },
      ];
    },
  },
  methods: {
    closePopUp() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.mortgage-summary-help-info-tooltip {
  margin-top: 12px;
}

.bold {
  font-weight: bold;
}
</style>
